
import { Col, Container, Row } from "react-bootstrap";
import Slideshow from '../components/widget/Slideshow'
import classes from "./PortfolioPage.module.css";

function PortfolioPage() {

  const investidorLibertarioLabel = "INVESTIDOR LIBERTÁRIO";
  const investidorLibertarioDescription = "Sistema sem fins comerciais desenvolvido como prova de conceito para demonstrar competências técnicas na construção de soluções completas, integrando diferentes camadas de uma aplicação. A solução realiza a coleta automatizada de dados em fontes online, seguida do processamento, organização e disponibilização das informações. A interface foi projetada para oferecer uma experiência intuitiva, permitindo a visualização e análise dos dados de forma clara, apoiando a tomada de decisões objetivas e seguras no ambiente financeiro.<br/><br/><b>Tecnologias utilizadas:</b> Python, PHP e React";
  const investidorLibertarioLink = "https://www.investidorlibertario.terradata.com.br";
  const investidorLibertarioSlides = [
    { url: "/img/produtos/investidor-libertario-01.png" },
    { url: "/img/produtos/investidor-libertario-02.png" },
    { url: "/img/produtos/investidor-libertario-03.png" },
    { url: "/img/produtos/investidor-libertario-04.png" },
  ];

  const relatorioEleitoralLabel = "RELATÓRIO ELEITORAL";
  const relatorioEleitoralDescription = "Produto desenvolvido para candidatos ao poder legislativo ou executivo.<br/> Compila informações disponíveis nos boletins do Tribunal Superior Eleitoral e provê visualização gráfica detalhada sobre a votação, permitindo análises comparativas por seção eleitoral, identificação de padrões de desempenho e suporte à tomada de decisões estratégicas durante e após o processo eleitoral.<br/><br/><b>Tecnologias utilizadas:</b> Java, Javascript, HTML e CSS.";
  const relatorioEleitoralLink = "https://www.terradata.com.br/amostras/relatorio-eleitoral";
  const relatorioEleitoralSlides = [
    { url: "/img/produtos/relatorio-eleitoral-01.png" },
    { url: "/img/produtos/relatorio-eleitoral-02.png" },
    { url: "/img/produtos/relatorio-eleitoral-03.png" },
    { url: "/img/produtos/relatorio-eleitoral-04.png" },
    { url: "/img/produtos/relatorio-eleitoral-05.png" },
    // { url: "/img/produtos/relatorio-eleitoral-06.png" },
    // { url: "/img/produtos/relatorio-eleitoral-07.png" },
    // { url: "/img/produtos/relatorio-eleitoral-08.png" },
    // { url: "/img/produtos/relatorio-eleitoral-09.png" }
  ];

  return (
    <main>
      <section id="portfolio" className={classes.portfolio}>
        <div className="interface">
          <h2 className="titulo">NOSSO <span>PORTFÓLIO.</span></h2>
          <div className={`flex ${classes.flex}`}>
            <Container>
              <Row>
                <Col sm className="p-3">
                  <Slideshow
                    slides={relatorioEleitoralSlides}
                    label={relatorioEleitoralLabel}
                    description={relatorioEleitoralDescription}
                    link={relatorioEleitoralLink} />
                  <small className="text-light">MELHOR VISUALIZADO EM COMPUTADORES</small>
                </Col>

                <Col sm className="p-3">
                  <Slideshow
                    slides={investidorLibertarioSlides}
                    label={investidorLibertarioLabel}
                    description={investidorLibertarioDescription}
                    link={investidorLibertarioLink} transition='2.5'
                  />
                  <small className="text-light">MELHOR VISUALIZADO EM COMPUTADORES</small>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </section>
    </main>
  );
}

export default PortfolioPage;